<template>
  <div id="app">
    <!-- Header hiển thị VietCloud + auth -->
    <header v-if="showHeader" class="app-header">
      <h1 class="logo-title">VietCloud</h1>

      <div class="spacer"></div>

      <div class="auth-wrapper">
        <h2 v-if="username" class="hello-text">Hello, {{ username }}</h2>
        <div class="auth-btn">
          <router-link v-if="!username" to="/login">
            <button class="btn-login">Login</button>
          </router-link>
          <button v-else class="btn-logout" @click="logout">Logout</button>
        </div>
      </div>
    </header>

    <router-view />
    <!-- ✅ PAYMENT SUCCESS POPUP -->
    <div v-if="showPaymentSuccessPopup" class="premium-popup-overlay">
      <div class="premium-popup">
        <h2>🎉 Payment Successful</h2>
        <p>
          Your payment has been completed successfully.<br /><br />
           Invoice details are available in your <b>Profile</b>.<br />
           Please refresh the page for the best experience.
        </p>
        <button @click="handlePaymentPopupConfirm">
          Got it
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  forceLogout,
  refreshToken as refreshTokenService,
  getUserInfo,
} from "@/services/authService";
export default {
  name: "App",
  data() {
    return {
      username: this.getCookie("username") || "",
      refreshInterval: null, // interval refresh token
      hasEverLoggedIn: localStorage.getItem("vietcloud_has_ever_logged_in") === "1",

    // 🆕 detect sleep / wake
    lastActiveTime: Date.now(),
    wakeHandlerBound: null,

    showPaymentSuccessPopup: false,

    };
  },
  computed: {
    showHeader() {
      const path = this.$route.path;
      return !(path === "/login" || path === "/signup" || path === "/Billing" || path === "/billing" || path === "/terms" || path === "/privacy");
    },
  },
  methods: {
    getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    },
    stopAppAndRedirect() {
      console.warn("🛑 Account inactive → stop app");

      // 1️⃣ clear ALL intervals
      if (this.refreshInterval) clearInterval(this.refreshInterval);
      if (this.cookieCheckInterval) clearInterval(this.cookieCheckInterval);

      // 2️⃣ clear local state
      this.username = "";

      // 3️⃣ redirect sang trang reload
      this.$router.replace("/reload");
    },
  handlePaymentPopupConfirm() {
    this.showPaymentSuccessPopup = false;

    // 🔥 XOÁ payment=success KHỎI HASH
    this.$router.replace({ path: this.$route.path });

    // 🔄 reload sau khi URL sạch
    setTimeout(() => {
      window.location.reload();
    }, 50);
  }, 

      // 🆕 HANDLE WAKE FROM SLEEP
    handleWakeUp() {
      const now = Date.now();
      const diff = now - this.lastActiveTime;

      // > 25 phút (token có thể hết hạn)
      if (diff > 15 * 60 * 1000) {
        console.log("💤 Wake after long idle → reload");
        window.location.reload();
        return;
      }

      this.lastActiveTime = now;
    },

    // 🆕 REGISTER LISTENERS
    setupWakeListeners() {
      this.wakeHandlerBound = this.handleWakeUp.bind(this);

      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          this.wakeHandlerBound();
        }
      });

      window.addEventListener("focus", this.wakeHandlerBound);

      window.addEventListener("mousemove", () => {
           this.lastActiveTime = Date.now();
        });
    },
    async logout() {
      console.log("👋 Manual logout");

      // 1️⃣ STOP all intervals (QUAN TRỌNG)
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }

      if (this.cookieCheckInterval) {
        clearInterval(this.cookieCheckInterval);
        this.cookieCheckInterval = null;
      }

      // 2️⃣ Clear Vue state NGAY LẬP TỨC
      this.username = "";

      // 3️⃣ Call backend + clear browser
      await forceLogout();

      // 4️⃣ Điều hướng SPA (tránh cookie sync chạy lại)
      this.$router.replace("/login");
    },

    async syncAuthSafe() {
      if (!this.hasEverLoggedIn) {
        console.log("ℹ️ First visit – skip auth sync");
        return;
      }

      try {
        // 1️⃣ refresh token
        await refreshTokenService();

        // 2️⃣ lấy user info
        const data = await getUserInfo();

        // 🔥 user bị ban / inactive
        if (data.is_active === false) {
          await forceLogout();
          return;
        }

        // 3️⃣ update UI + cookie
        this.username = data.username;

        document.cookie = `username=${data.username}; path=/`;
        document.cookie = `email=${data.email}; path=/`;

        console.log("✅ Auth synced:", data.username);
      } catch (err) {
        console.error("syncAuthSafe error:", err);
        this.username = "";
      }
    },
    // -------------------------------
    // 🔄 Refresh token tự động
    // -------------------------------
    async refreshToken() {
      try {
        await refreshTokenService();
        console.log("Access token refreshed successfully");
      } catch (err) {
        console.warn("Refresh token failed");
        this.logout();
      }
    }
  },
  mounted() {
    // sessionStorage.removeItem("vietcloud_force_logged_out");
    // sessionStorage.removeItem("vietcloud_manual_logout");
    if (this.hasEverLoggedIn) {
      this.syncAuthSafe();
    }
        // ✅ DETECT STRIPE PAYMENT SUCCESS
    const hash = window.location.hash; // "#/?payment=success"
    const queryString = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(queryString);
    

    if (params.get("payment") === "success") {
      this.showPaymentSuccessPopup = true;
    }

    if (this.username) this.refreshToken();
    // Đồng bộ cookie username mỗi giây để update UI
    this.setupWakeListeners();
    this.cookieCheckInterval = setInterval(() => {
      const cookieUsername = this.getCookie("username") || "";
      if (cookieUsername !== this.username) {
        this.username = cookieUsername;
      }
    }, 1000);

    // Refresh token tự động 29 phút 1 lần
    this.refreshInterval = setInterval(() => {
      this.refreshToken();
    }, 29 * 60 * 1000); // 20 mins

    // Watch route thay đổi
    this.$watch(
      () => this.$route.path,
      () => {
        this.username = this.getCookie("username") || "";
      }
    );
  },
  beforeUnmount() {
    clearInterval(this.cookieCheckInterval);
    clearInterval(this.refreshInterval);
    // window.removeEventListener("focus", this.refreshToken);
  },
};
</script>


<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  margin: 2px;
}

/* Header flex: logo trái, auth phải */
.app-header {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 6px 0;
  margin-bottom: 15px;
}

/* Spacer đẩy auth sang phải */
.spacer {
  flex: 1;
}

/* Wrapper cho Hello + auth, lùi vào 50px */
.auth-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 42px; 
}

/* Logo */
.logo-title {
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
  color: #2196f3;
}

/* Hello text giống Home.vue */
.hello-text {
  font-size: 2rem;
  font-weight: 500;
  color: #2196f3;
  font-family: "Segoe UI", sans-serif;
  margin: 0;
  flex-shrink: 0;
}

/* Auth button wrapper */
.auth-btn {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Login button */
.btn-login {
  width: 180px;
  padding: 8px 16px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
  background: #FFA500;
  color: #fff;
}
.btn-login:hover {
  background: #d48a00;
}

/* Logout button */
.btn-logout {
  width: 180px;
  padding: 8px 16px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
  background: #f1392c;
  color: #fff;
}
.btn-logout:hover {
  background: #d32f2f;
}

.premium-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.premium-popup {
  background: white;
  padding: 30px 35px;
  border-radius: 18px;
  text-align: center;
  max-width: 420px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}

.premium-popup h2 {
  color: #007bff;
  margin-bottom: 12px;
}

.premium-popup p {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 22px;
}

.premium-popup button {
  padding: 12px 26px;
  border: none;
  border-radius: 25px;
  background: #007bff;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

/* ================= MOBILE RESPONSIVE HEADER ================= */
@media (max-width: 768px) {

  /* Header gọn lại */
  .app-header {
    padding: 4px 6px;
    gap: 8px;
    margin-bottom: 10px;
  }

  /* Logo VietCloud nhỏ hơn */
  .logo-title {
    font-size: 1.3rem;   /* từ 2rem → 1.3rem */
  }

  /* Hello text nhỏ hơn */
  .hello-text {
    font-size: 1.1rem;   /* từ 2rem → 1.1rem */
  }

  /* Wrapper auth sát hơn, không đẩy quá xa */
  .auth-wrapper {
    gap: 6px;
    margin-right: 10px;  /* từ 42px → 10px */
  }

  /* Nút login / logout nhỏ lại RÕ RỆT */
  .btn-login,
  .btn-logout {
    width: auto;          /* bỏ fixed 180px */
    min-width: 80px;
    padding: 5px 12px;    /* nhỏ hơn nhiều */
    font-size: 0.8rem;    /* chữ nhỏ */
    border-radius: 20px;
  }

  /* Wrapper nút không bị tràn */
  .auth-btn {
    gap: 6px;
  }
}


</style>
